import type { SeoListing } from "./seo-data";

const KNOWN_ARMORERS = [
  "Carbon",
  "Steel Plate",
  "TecnoBlinda",
  "Maxblindados",
  "Centigon",
  "Armorbras",
  "Inkas",
  "AutoBlindados",
  "TopBlindados",
];

export function inferArmorers(listings: SeoListing[]): string[] {
  const counts = new Map<string, number>();
  for (const l of listings) {
    const direct = l.armorer ?? l.blindadora;
    const hay = `${l.title ?? ""} ${l.display_title ?? ""}`.toLowerCase();
    const found = direct ?? KNOWN_ARMORERS.find((n) => hay.includes(n.toLowerCase()));
    if (found) counts.set(found, (counts.get(found) ?? 0) + 1);
  }
  return Array.from(counts.entries())
    .sort((a, b) => b[1] - a[1])
    .slice(0, 3)
    .map(([n]) => n);
}

export function inferCities(listings: SeoListing[]): string[] {
  const counts = new Map<string, number>();
  for (const l of listings) {
    const city = l.city ?? (l.location ? l.location.split("·")[0]?.trim() : null);
    if (city) counts.set(city, (counts.get(city) ?? 0) + 1);
  }
  return Array.from(counts.entries())
    .sort((a, b) => b[1] - a[1])
    .slice(0, 4)
    .map(([n]) => n);
}

/**
 * Format a "freshness" badge from an ISO timestamp. Caller passes
 * `stats.lastUpdatedAt` directly (computed server-side via MAX(first_seen_at)
 * in the seo_stats RPC) — no need to slice a sample of listings.
 */
export function lastUpdatedAgo(iso: string | null | undefined): string {
  if (!iso) return "hoje";
  const ts = new Date(iso).getTime();
  if (Number.isNaN(ts)) return "hoje";
  const diff = Date.now() - ts;
  const m = Math.floor(diff / 60000);
  if (m < 60) return `há ${Math.max(m, 1)} min`;
  const h = Math.floor(m / 60);
  if (h < 24) return `há ${h} h`;
  const d = Math.floor(h / 24);
  return `há ${d} d`;
}
